export type CheckLetterOfOfferResponse = {
  status: 'lo-assigned' | 'not-available';
  message: string;
};

export type LetterOfOfferSignMethod = 'singpass' | 'manual';
export const LetterOfOfferSignMethod: Record<Capitalize<LetterOfOfferSignMethod>, LetterOfOfferSignMethod> = {
  Singpass: 'singpass',
  Manual: 'manual',
};
